import { render } from "./payzen_payment.vue?vue&type=template&id=0cf203d2&scoped=true"
import script from "./payzen_payment.vue?vue&type=script&lang=js"
export * from "./payzen_payment.vue?vue&type=script&lang=js"

import "./payzen_payment.vue?vue&type=style&index=0&id=0cf203d2&scoped=true&lang=css"

import exportComponent from "/Users/bettachristian-david/Documents/Accen/Site résa/reservation.ogalo-saumurvaldeloire.fr/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cf203d2"]])

export default __exports__